export default {
  statusApproved: 'Approved',
  statusBlockedNatura: 'Blocked',
  statusDraft: 'Suggested for start',
  statusGaveup: 'Desistance',
  statusPending: 'Suggested for start',
  statusRejected: 'Disapproved',
}
